import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasStepDetails = lazy(() =>
  import("@canvas/CanvasStepDetails").then((module) => ({
    default: module.CanvasStepDetails,
  }))
);

export const canvasStepDetailsNRO: NavigationRoutingObject = {
  Component: CanvasStepDetails,
  componentFeatureFlippers: ["canvas_step_details_nro_component"],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-sidebar-pill-menu-option", "Canvas"),
  icon: "new-nav-system-canvas",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("journeys");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/canvas/:appGroupId",
};
